import React, { useState } from 'react';


import openImage from 'assets/img/icons/open.svg';
import closedImage from 'assets/img/icons/closed.svg';
import {
  Container, Text, Icon, Row,
} from './styles';

function Colapse({ title, children, icon }) {
  const [maximized, setMaximized] = useState(false);
  return (
    <Container maximized={maximized}>
      <Row active={maximized}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Icon
            src={icon}
            alt="ícone de ação"
          />
          <Text>
            {title}
          </Text>
        </div>
        <Icon
          onClick={() => setMaximized(!maximized)}
          src={maximized ? openImage : closedImage}
          alt="minimizar ou expandir ícone"
        />
      </Row>
      {maximized
        && (
        <div style={{ backgroundColor: '#fff' }}>
          {children}
        </div>
        )
      }
    </Container>
  );
}

export default Colapse;
